import { createFileUploadModalState } from '../services';
import { FILE_UPLOAD_ALL_FILES_UPLOAD_START, FILE_UPLOAD_ALL_FILES_UPLOAD_SUCCESS, FILE_UPLOAD_CLOSE_MODAL, FILE_UPLOAD_RC_ALL_FILES_UPLOAD_START, FILE_UPLOAD_RC_ALL_FILES_UPLOAD_SUCCESS, FILE_UPLOAD_RC_CLOSE_MODAL } from '../actions';
export const fileUploadModalRootReducer = (state = createFileUploadModalState(), action) => {
    var _a;
    switch (action.type) {
        case FILE_UPLOAD_ALL_FILES_UPLOAD_SUCCESS:
            return { isOpen: !!(((_a = action.payload) === null || _a === void 0 ? void 0 : _a.isEnhancedPhotoCaptureEnabled) && action.payload.isMobile) };
        case FILE_UPLOAD_RC_ALL_FILES_UPLOAD_SUCCESS:
        case FILE_UPLOAD_CLOSE_MODAL:
        case FILE_UPLOAD_RC_CLOSE_MODAL:
            return { isOpen: false };
        case FILE_UPLOAD_ALL_FILES_UPLOAD_START:
        case FILE_UPLOAD_RC_ALL_FILES_UPLOAD_START:
            return { isOpen: true };
        default:
            return state;
    }
};
//# sourceMappingURL=fileUploadModalRootReducer.js.map